import { useNavigate } from 'react-router-dom';

import { StreamMobileHistoryMoves } from '../moves-history';
import { RoomDescriptionText } from '../room-description-text';

import PrimaryButton from 'shared/components/ui/PrimaryButton/PrimaryButton';
import { ROUTES } from 'shared/constants';
import { useAccount } from 'shared/hooks/use-web3';

import ControllerIcon from 'assets/controller-brown.svg?react';
import WalletIcon from 'assets/wallet-brown.svg?react';

interface IStreamRoomFooterProps {
  currentRound: number;
  isGameFinished: boolean;
  roomDescription?: string;
}

export const StreamRoomFooter = ({
  currentRound,
  isGameFinished,
  roomDescription,
}: IStreamRoomFooterProps) => {
  const navigate = useNavigate();
  const { isConnected } = useAccount();

  return (
    <div className="flex w-full flex-col">
      <StreamMobileHistoryMoves currentRound={currentRound} isGameFinished={isGameFinished} />

      <div className="z-50 w-full border-t border-indigo bg-grape pt-2 lg:hidden">
        <PrimaryButton
          onClick={() => navigate(ROUTES.LOBBY)}
          text={isConnected ? 'pages.stream.playGame' : 'pages.stream.connectWallet'}
          svg={
            isConnected ? (
              <ControllerIcon className="h-5 w-5 sm:h-6 sm:w-6" />
            ) : (
              <WalletIcon className="h-5 w-5 sm:h-6 sm:w-6" />
            )
          }
          isAnimated
          className="w-full"
        />
      </div>

      <RoomDescriptionText isMobile roomDescription={roomDescription} />
    </div>
  );
};
